import {createSlice} from "@reduxjs/toolkit";

const initialManageTownsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  ManageTownForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const ManageTownSlice = createSlice({
  name: "ManageTown",
  initialState: initialManageTownsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getCustomerById
    townFetched: (state, action) => {
      state.actionsLoading = false;
      state.ManageTownForEdit = action.payload.ManageTownForEdit;
      state.error = null;
    },
    // findTowns
    townsFetched: (state, action) => {
      // const { totalCount, entities } = action.payload;
      const { length, data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = data;
      state.totalCount = length;
     
    },

    
     // createCustomer
     TownCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.data);
    },
   
    // updateTown
    TownUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.ManageTown.id) {
          return action.payload.ManageTown;
        }
        return entity;
      });
    },
    // deleteCustomer
    townDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteCustomers
    customersDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // customersUpdateState
    customersStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
